/**
 * @deprecated Это легаси цвета, не используй их!
 */
export var LegacyColors = {
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  black: '#000',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  white: '#fff',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack80: 'rgba(0, 0, 0, 0.8)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack70: 'rgba(0, 0, 0, 0.7)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack60: 'rgba(0, 0, 0, 0.6)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack50: 'rgba(0, 0, 0, 0.5)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack40: 'rgba(0, 0, 0, 0.4)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack30: 'rgba(0, 0, 0, 0.3)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack25: 'rgba(0, 0, 0, 0.25)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack20: 'rgba(0, 0, 0, 0.2)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack15: 'rgba(0, 0, 0, 0.15)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack10: 'rgba(0, 0, 0, 0.1)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack7: 'rgba(0, 0, 0, 0.07)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack5: 'rgba(0, 0, 0, 0.05)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack3: 'rgba(0, 0, 0, 0.03)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite10: 'rgba(255, 255, 255, 0.1)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite15: 'rgba(255, 255, 255, 0.15)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite30: 'rgba(255, 255, 255, 0.3)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite50: 'rgba(255, 255, 255, 0.5)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite80: 'rgba(255, 255, 255, 0.8)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite90: 'rgba(255, 255, 255, 0.9)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  gray: '#E0E0E0',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  grayLight: '#F0F3F7',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  backgroundgray: '#F2F4F7',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaInputRegular: 'rgba(0, 41, 91, 0.06)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  utblue: '#004BFF',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  utblueHover: '#447BFF',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  utBlueActive: '#003DD0',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  proBlue: '#176CD4',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  blue: '#0B5ACD',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  blueLight50: '#3187EE',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight55: 'rgba(23, 108, 212, 0.1)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight60: 'rgba(23, 108, 212, 0.2)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight65: 'rgba(0, 75, 185, 0.15)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight75: 'rgba(23, 108, 212, 0.1)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  orange: '#FF8800',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaOrangeLight65: 'rgba(217, 116, 0, 0.2)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  orangeLight75: '#FFF3E6',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  brown: '#65290D',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaYellowLight65: 'rgba(101, 41, 13, 0.1)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  yellowLight75: '#FFF8D9',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  green: '#3BA900',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  greenBright10: '#4ECF00',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaGreenLight65: 'rgba(59, 169, 0, 0.2)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  greenLight75: '#E2F2D9',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  red: '#ED4040',

  /* Цвета для ui-kit компонента Hint */

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintWarning: '#FFDC4C',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintError: '#FF9A26',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintInfo: '#D7E2EF',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintSuccess: '#72C233',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintAlert: '#F1DED8',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintBuy: '#3187EE',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintSell: '#ED4040'
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/common/Colors/LegacyColors.js
// module id = 1657
// module chunks = 118